/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Delivered_ToInputs */

const vi_order_delivered_to = /** @type {(inputs: Order_Delivered_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao đến ngày`)
};

/**

* @param {Order_Delivered_ToInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_delivered_to = /** @type {((inputs?: Order_Delivered_ToInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Delivered_ToInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_delivered_to(inputs)
});